import { Component, Input } from '@angular/core';

@Component({
  selector: 'binding-card',
  templateUrl: './binding-card.component.html',
  styleUrls: ['./binding-card.component.scss'],
})
export class BindingCardComponent {
  @Input() title: string;
  @Input() description: string;
  @Input() image: 'classic' | 'layflat' = 'classic';
}
